import { FETCH_NOTIFICATION_UNREAD_COUNT, FETCH_NOTIFICATIONS, MARK_NOTIFICATION_READ, MARK_NOTIFICATION_UNREAD } from '../constants/actionTypes.js';
import * as api from '../api/index.js';

export const fetchUnreadCount = () => async (dispatch) => {    
    try {

        const {data} = await api.fetchUnreadCount()
        dispatch({ type: FETCH_NOTIFICATION_UNREAD_COUNT, payload: data });

    } catch (error) {
        console.error(error.response?.data);   
        console.error(error.response?.status);
        
    }
}

export const fetchNotifications = () => async (dispatch) => {
  try {
    const { data } = await api.fetchNotifications(); 
    console.log(data);
    
    dispatch({ type: FETCH_NOTIFICATIONS, payload: data });
  } catch (error) {
    console.error(error.response?.data);
    console.error(error.response?.status);
  }
};

export const markNotificationRead = (id) => async (dispatch) => {
  try {
    // backend expects array of ids
    await api.markRead([id]);
    dispatch({ type: MARK_NOTIFICATION_READ, payload: id });
  } catch (error) {
    console.error('markNotificationRead failed:', error.response?.data || error);
  }
};


export const markNotificationUnread = (id) => async (dispatch) => {
  try {
    await api.markUnread([id]);
    dispatch({ type: MARK_NOTIFICATION_UNREAD, payload: id }); // optimistic
  } catch (err) {
    console.error('markNotificationUnread failed:', err.response?.data || err);
  }
};